module.exports = __webpack_public_path__ + "static/media/00.43ee1753.png";